/**
 * Created by noOne on 15/02/2018.
 */
"use strict";

export default class StackedDuplicate extends PIXI.Container {
    constructor(name, frameWidth, frameHeight) {
        super();

        this._layers = [];
        this._collisionRect = null;

        // this.scale.set(2);
        const t = Common.assets.texture;
        // grab textures from sheet and pop them into a convenient array where they can be accessed using the tile id as the index
        let sheet = t(name).baseTexture;
        sheet.scaleMode = PIXI.SCALE_MODES.NEAREST;

        let wid = frameWidth;
        let hei = frameHeight;

        let textures = [];
        let total = sheet.width / wid;
        //let tilesPerCol = sheet.height / Common.tileSize;
        // let totalTileTextures = 21;
        for (let i = 0; i < total - 1; i++) {
            textures.push(new PIXI.Texture(sheet, new PIXI.Rectangle(i * wid, 0, wid, hei)));
        }

        if (name === "tree") this._isTree = true;
        //textures = textures.reverse();

        this._textures = textures;

        this.init();
    }

    init() {

        for (let i = 0; i <= this._textures.length; i++) {
            //let sp = P3.utils.sprite(t("iso_" + i), this, new PIXI.Point(0.5, 0.5));
            let sp = new PIXI.Sprite(this._textures[i]); //new PIXI.extras.TilingSprite(t("dirt_strip"), 32, 32);
            //sp.width = 16;
            sp.anchor.set(0.5);
            //sp.tilePosition.x = Math.round(Math.random() * 32);
            //sp.tilePosition.y = Math.round(Math.random() * 32);
            if (!this._isTree) {
                sp.y = -i;
            } else {
                sp.y = -i * 8;
                sp.scale.set(4);
            }
            // * 12;
            //sp.scale.set(81);

            //if (Math.random() < 0.5) sp.scale.x = -sp.scale.x;
            //if (Math.random() < 0.5) sp.scale.y = -sp.scale.y;

            this._layers.push(sp);
            this.addChild(sp);
        }
    }

    update(dir) {
        for (let i = 0; i < this._layers.length; i++) {
            this._layers[i].rotation += deltaTime * dir;
        }

        //this._collisionRect.rotation += deltaTime * dir;
    }

    get collisionRect() {
        return this._layers[0];
    }
}